export default __webpack_public_path__ + "static/media/flyback_controller_dc_psr_neg.64d43705.svg";